import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Newsletter from "@/components/Newsletter";
import { FadeIn, ChapterLabel } from "@/components/Reveal";
import { NEWS } from "@/data/content";
import useSEO from "@/hooks/useSEO";

export default function News() {
  useSEO(
    "News & Reading Lists for Ages 4-8 | The Cap Chronicles",
    "Book news, seasonal reading lists for kids ages 4-8, story-time events, and quiet notes from The Cap Chronicles studio."
  );
  return (
    <main>
      <PageHero
        kicker="The Journal"
        title="News from"
        italic="the Vale."
        description="New books, seasonal reading lists for ages 4-8, story-time events, and quiet notes from the studio desk."
      />

      <section className="mx-auto max-w-5xl px-6 pb-24 md:px-12 md:pb-32" data-testid="news-list">
        <ChapterLabel num="01" title="Latest Entries" />
        <div className="flex flex-col">
          {NEWS.map((n, i) => (
            <FadeIn key={n.id} delay={i * 0.08}>
              <article className="group grid cursor-pointer items-center gap-8 border-t border-charcoal/10 py-10 md:grid-cols-[220px_1fr_auto]" data-testid={`news-article-${n.id}`}>
                <div className="overflow-hidden rounded-2xl">
                  <img src={n.img} alt={n.title} className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                </div>
                <div>
                  <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em]">
                    <span className="text-gold">{n.tag}</span>
                    <span className="h-1 w-1 rounded-full bg-charcoal/30" />
                    <span className="text-charcoal/50">{n.date}</span>
                  </div>
                  <h2 className="mt-2 font-serif text-2xl leading-snug tracking-tight transition-colors duration-300 group-hover:text-forest md:text-3xl">{n.title}</h2>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-charcoal/65 md:text-base">{n.excerpt}</p>
                </div>
                <span className="hidden h-12 w-12 items-center justify-center rounded-full border border-charcoal/15 text-charcoal/50 transition-all duration-300 group-hover:border-forest group-hover:bg-forest group-hover:text-cream md:flex">
                  <ArrowUpRight size={17} />
                </span>
              </article>
            </FadeIn>
          ))}
          <div className="border-t border-charcoal/10" />
        </div>
      </section>

      <Newsletter />
    </main>
  );
}
